/**
 * AdminRoute — wraps a protected route with an additional admin gate.
 * The `isAdmin` flag comes from the server (/user/profile), so the allowlist
 * lives in exactly one place (the Lambdas). This is purely a UX safeguard
 * against rendering an admin shell to a non-admin — every admin API route
 * re-checks the caller's email server-side.
 */

import { useIsAdmin } from '../hooks/useIsAdmin.js';
import ProtectedRoute from './ProtectedRoute.jsx';
import { theme } from '../constants/theme.js';

export default function AdminRoute({ children }) {
  return (
    <ProtectedRoute>
      <AdminGate>{children}</AdminGate>
    </ProtectedRoute>
  );
}

function AdminGate({ children }) {
  const { isAdmin, loading } = useIsAdmin();
  if (loading) return null;
  if (!isAdmin) {
    return (
      <div
        className="h-dvh flex items-center justify-center p-6"
        style={{ backgroundColor: theme.bg }}
      >
        <div
          className="max-w-md w-full rounded-2xl p-8 text-center"
          style={{ background: theme.card, border: `1px solid ${theme.border}` }}
        >
          <div className="text-4xl mb-3" aria-hidden="true">🛡️</div>
          <h1 className="text-xl font-bold mb-2" style={{ color: theme.t1 }}>
            Admin access required
          </h1>
          <p className="text-sm" style={{ color: theme.t3 }}>
            This page is restricted to Atlas Casino administrators.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
